import { Utils } from '@pbt/pbt-ui-components'

import {
  MASTER,
  PROD,
  SEGMENT_ENV_IDS,
  STAGE,
} from '../constants/environmentVariables'
import { registerTrackingProvider } from './trackingProvider'

let isKioskAnalyticsTrackingProviderRegistered = false

const getKioskEnvironmentFromHostname = (hostname: string): string => {
  if (hostname.includes('.master.')) {
    return MASTER
  }

  if (hostname.includes('.stage.')) {
    return STAGE
  }

  return PROD
}

export const getKioskAnalyticsEnvironment = (): string => {
  if (Utils.isLocalEnvironment()) {
    return localStorage.getItem('devEnv') || STAGE
  }

  return getKioskEnvironmentFromHostname(window.location.hostname)
}

export const getKioskSegmentEnvId = (): string | undefined => {
  const env = getKioskAnalyticsEnvironment()

  if (env !== PROD && env !== MASTER && env !== STAGE) {
    return SEGMENT_ENV_IDS[STAGE]
  }

  return SEGMENT_ENV_IDS[env]
}

export const setIsKioskAnalyticsTrackingProviderRegistered = (
  value: boolean,
): void => {
  isKioskAnalyticsTrackingProviderRegistered = value
}

export const initKioskAnalytics = (): void => {
  if (isKioskAnalyticsTrackingProviderRegistered) {
    return
  }

  registerTrackingProvider({
    track: (eventName, meta = {}) => {
      const { analytics } = window as any

      if (analytics?.track) {
        analytics.track(eventName, meta)
      }
    },
  })

  isKioskAnalyticsTrackingProviderRegistered = true
}
